/** @jsx jsx */
import { jsx } from 'theme-ui'
import { string } from 'prop-types'

const ToolTipIcon = ({ color = '#D6DBD8' }) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7.63916" r="7" fill={color} />
      <path
        d="M7.00361 5.19823C6.85776 5.19823 6.73346 5.14851 6.6307 5.04907C6.52794 4.94962 6.47656 4.82366 6.47656 4.67118C6.47656 4.5187 6.52794 4.39274 6.6307 4.2933C6.73346 4.19054 6.85776 4.13916 7.00361 4.13916C7.15278 4.13916 7.27874 4.19054 7.3815 4.2933C7.48757 4.39274 7.54061 4.5187 7.54061 4.67118C7.54061 4.81703 7.48757 4.94134 7.3815 5.04409C7.27874 5.14685 7.15278 5.19823 7.00361 5.19823ZM7.40139 11.5825H6.58595V6.49099H7.40139V11.5825Z"
        fill="black"
      />
    </svg>
  )
}

ToolTipIcon.propTypes = {
  color: string,
}

export default ToolTipIcon
